var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LookGoods"},[_c('div',{staticClass:"lookBtn",on:{"click":function($event){return _vm.$router.push('/Goods?k=1')}}},[_c('img',{attrs:{"src":require("../assets/img/lookBtn.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }